<template>
  <div>
    <Head title="Carboidratos" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Contagem de Carboidratos</h1>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="carbs/list"
        no-data-label="Nenhum carboidrato cadastrado"
        no-result-label="Nenhum carboidrato encontrado"
      >
        <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
    
        <template #after.reload-button>
            <button class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Contagem</span>
            </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit ref="modalEdit" title="Contagem de Carboidratos" url="carbs" @submitForm="reloadTable">
      <template #form="{item}">
        <text-input v-model="item.food" :error="item.errors.food" class="lg:pr-6 w-full lg:w-1/2" label="Alimento" />
        <select-input v-model="item.usual_measure" :error="item.errors.usual_measure" class="mt-6 lg:mt-0 w-full lg:w-1/2" label="Medida usual">
          <option :value="null" />
          <option v-for="(value, name, index) in usual_measures" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <select-input v-model="item.measure" :error="item.errors.measure" class="mt-6 lg:pr-6 w-full lg:w-1/2" label="Medida (g ou ml)">
          <option :value="null" />
          <option v-for="(value, name, index) in measures" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <text-input v-model="item.amount_carbs" :error="item.errors.amount_carbs" class="mt-6 w-full lg:w-1/2" label="Quantidade de carboidratos (g)" />
        <text-input v-model="item.calories" :error="item.errors.calories" class="lg:pr-6 mt-6 w-full lg:w-1/2" label="Calorias (kcal)" />
        <textarea-input v-model="item.description" :error="item.errors.description" class=" mt-6 w-full" label="Observações para diabéticos" />
      </template>
    </modal-edit>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import SwitchInput from '@/Shared/SwitchInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import TextareaInput from '@/Shared/TextareaInput'
import DataTable from '@/Shared/DataTable'

export default {
  props: {
    measures: Object,
    usual_measures: Object,
  },
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    SwitchInput,
    TextInput,
    TextareaInput,
    SelectInput,
    DataTable,
  },
  layout: Layout,
  data() {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'carb_food',
          label: 'Alimento',
          field: 'food',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'carb_usual_measure',
          label: 'Medida usual',
          field: 'usual_measure',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.usual_measure_label
        },
        {
          uniqid: 'carb_measure',
          label: 'Medida',
          field: 'measure',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.measure_label
        },
        {
          uniqid: 'carb_amount_carbs',
          label: 'Carboidratos (g)',
          field: 'amount_carbs',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.amount_carbs ?? ''
        },
        {
          uniqid: 'carb_calories',
          label: 'Calorias (kcal)',
          field: 'calories',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.calories ?? ''
        },
        {
          uniqid: 'carb_description',
          label: 'Observações para diabéticos',
          field: 'description',
          visible: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val.substr(0, 50) : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/carbs/${item.id}`, `Deseja realmente excluir o carboidrato ${item.food}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        food: item.food,
        calories: item.calories,
        amount_carbs: item.amount_carbs,
        usual_measure: item.usual_measure,
        measure: item.measure,
        description: item.description,
        errors: {}
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    }
  },
}
</script>